const autoScroll = ref => {
  setTimeout(() => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  }, 1000);
};

export { autoScroll };
